<template>
	<v-col class="reward">
		<div class="d-flex justify-space-between">
			<div class="font-size-14 font-weight-bold secondary--text">List Reward Ekonomi</div>
		</div>

		<template v-if="!loading">
			<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
				<div class="mt-5" v-if="showReward === 'rewardEkonomi'">
					<ListRewardEkonomi :currentPoint="pointRewardEkonomi" :point="pointRewardEkonomi"></ListRewardEkonomi>
				</div>
			</v-scroll-x-reverse-transition>
		</template>

		<template v-else>
			<v-row>
				<v-col cols="12" sm="12" md="12">
					<LoadData :loading="loading"></LoadData>
				</v-col>
			</v-row>
		</template>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ListRewardEkonomi from './components/ListRewardEkonomi';

export default {
	components: {
		ListRewardEkonomi
	},
	data() {
		return {
			loading: false,
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			showReward: 'rewardEkonomi',
		}
	},
	computed: {
		...mapState('reward', ['pointRewardEkonomi']),
	},
	methods: {
		...mapActions('reward', ['getRewardEkonomi']),

		getData() {
			// this.loading = true
			this.getRewardEkonomi(this.queryString({limit:this.limit, page: this.page, params:this.params})).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				// this.loading = false
			})
		},
	},
	created(){
		this.$store.dispatch('setPageTitle', `List Reward`)
		this.getData()
	}
};
</script>

